import ApplePayApi from '@/api/apple-pay'
import ApplePayApiV2 from '@/api/v2/apple-pay'

const state = {
  appleValidating: false,
}

const getters = {}

const mutations = {
  SET_REQUEST_STATUS: (state, { name, value }) => {
    state[name] = value
  },
}

const actions = {
  async validateApplePay({ commit, rootGetters }, validationURL) {
    try {
      commit('SET_REQUEST_STATUS', { name: 'appleValidating', value: true })

      let res = {}
      const isPcidssEnabled = rootGetters['configuration/isPcidssEnabled']
      const isPcidssApplePayEnabled =
        rootGetters['configuration/isPcidssApplePayEnabled']

      if (isPcidssEnabled && isPcidssApplePayEnabled) {
        res = await ApplePayApiV2.validateAppleSession(validationURL)
      } else {
        res = await ApplePayApi.validateAppleSession(validationURL)
      }

      commit('SET_REQUEST_STATUS', { name: 'appleValidating', value: false })

      return res
    } catch (error) {
      commit('SET_REQUEST_STATUS', { name: 'appleValidating', value: false })
    }
  },
}

export default { namespaced: true, state, getters, mutations, actions }
